import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { AngularFireDatabaseModule, AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

@Injectable()
export class UserService {

    user: Observable<firebase.User>;

    public onUserChange$: Subject<firebase.User>;
    constructor(public afAuth: AngularFireAuth,
        private database: AngularFireDatabase,
        private router: Router) {
        this.onUserChange$ = new Subject();
        this.user = this.afAuth.authState;
    }

    setUser(user: firebase.User) {
        this.onUserChange$.next(user);
        let userString = JSON.stringify(user);

        // Local saving
        localStorage.setItem("currentUser", userString);

        // Database update
        this.updateUserData();
    }

    getCurrentUser(): firebase.User {
        let userString = localStorage.getItem("currentUser");
        if (userString === null) {
            return null;
        } else {
            let user: firebase.User = JSON.parse(userString);
            return user;
        }
    }

    getCurrentUserId(): string {
        return this.getCurrentUser().uid;
    }

    getCurrentUserDisplayName(): string {
        return this.getCurrentUser().displayName;
    }

    getCurrentUserEmail(): string {
        return this.getCurrentUser().email;
    }

    getCurrentUserPhotoURL(): string {
        return this.getCurrentUser().photoURL;
    }

    getCurrentUserPhoneNumber(): string {
        return this.getCurrentUser().phoneNumber;
    }

    forgetCurrentUser() {
        this.onUserChange$.next(null);
        localStorage.removeItem("currentUser");
        this.user = null;
    }

    login(email: string, password: string) {
        this.afAuth.auth.signInWithEmailAndPassword(email, password).then((user) => {
            this.setUser(user);
        }).catch((err) => {
            console.log(err);
        })
    }

    logout() {
        this.afAuth.auth.signOut();
        this.forgetCurrentUser();
    }

    private updateUserData(): void {
        let userId = this.getCurrentUserId();
        let path = 'users/' + userId;
        let data = {
            email: this.getCurrentUserEmail()
        }
        this.database.object(path).update(data)
            .catch(error => console.log(error));
    }

    public getUserData() {
        let userId = this.getCurrentUserId();
        let path = 'users/' + userId;
        return this.database.object(path);
    }

    public updateUserDataValues(data) {
        let userId = this.getCurrentUserId();
        let path = 'users/' + userId;
        this.database.object(path).update(data)
            .catch(error => console.log(error));
    }
}



// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/services/user.service.ts